import * as React from "react";
function SvgSquareArrow(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M31 11V1H21M15 17L30 2M13 7H1v24h24V19"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgSquareArrow);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
